import { gql } from "@apollo/client";
import { LEGACY_TERM_SHEET_ASSIGNMENT_FIELDS, LEGACY_TERM_SHEET_FIELDS } from "graphql/fragments";

const UPDATE_LEGACY_TERM_SHEET_ASSIGNMENTS = gql`
  ${LEGACY_TERM_SHEET_ASSIGNMENT_FIELDS}
  mutation updateLegacyTermSheetAssignments($input: UpdateLegacyTermSheetAssignmentsInput!) {
    updateLegacyTermSheetAssignments(input: $input) {
      assignments {
        ...LegacyTermSheetAssignmentFields
      }
    }
  }
`;

const ADD_LEGACY_TERM_SHEET_ASSIGNMENTS = gql`
  ${LEGACY_TERM_SHEET_ASSIGNMENT_FIELDS}
  mutation AddLegacyTermSheetAssignments($input: AddLegacyTermSheetAssignmentsInput!) {
    addLegacyTermSheetAssignments(input: $input) {
      assignments {
        ...LegacyTermSheetAssignmentFields
      }
    }
  }
`;

const REMOVE_LEGACY_TERM_SHEET_ASSIGNMENT = gql`
  ${LEGACY_TERM_SHEET_ASSIGNMENT_FIELDS}
  mutation RemoveLegacyTermSheetAssignment($input: RemoveLegacyTermSheetAssignmentInput!) {
    removeLegacyTermSheetAssignment(input: $input) {
      assignments {
        ...LegacyTermSheetAssignmentFields
      }
    }
  }
`;

const UPDATE_ORGANIZATION_BILLING_ACCOUNT = gql`
  ${LEGACY_TERM_SHEET_FIELDS}
  mutation UpdateOrganizationBillingAccount($input: UpdateOrganizationBillingAccountInput!) {
    updateOrganizationBillingAccount(input: $input) {
      ...LegacyTermSheetFields
    }
  }
`;

const ADD_LEGACY_TERM_SHEET = gql`
  ${LEGACY_TERM_SHEET_FIELDS}
  mutation AddLegacyTermSheet($input: AddLegacyTermSheetInput!) {
    addLegacyTermSheet(input: $input) {
      ...LegacyTermSheetFields
    }
  }
`;

const UPDATE_LEGACY_TERM_SHEET = gql`
  ${LEGACY_TERM_SHEET_FIELDS}
  mutation UpdateLegacyTermSheet($input: UpdateLegacyTermSheetInput!) {
    updateLegacyTermSheet(input: $input) {
      ...LegacyTermSheetFields
    }
  }
`;

const REMOVE_LEGACY_TERM_SHEET = gql`
  mutation RemoveLegacyTermSheet($input: RemoveLegacyTermSheetInput!) {
    removeLegacyTermSheet(input: $input)
  }
`;

export {
  UPDATE_LEGACY_TERM_SHEET_ASSIGNMENTS,
  ADD_LEGACY_TERM_SHEET_ASSIGNMENTS,
  REMOVE_LEGACY_TERM_SHEET_ASSIGNMENT,
  UPDATE_ORGANIZATION_BILLING_ACCOUNT,
  ADD_LEGACY_TERM_SHEET,
  UPDATE_LEGACY_TERM_SHEET,
  REMOVE_LEGACY_TERM_SHEET,
};
